import React from 'react'
import { Select, MultiSelect, Global } from '@mantine/core'

const IconChevronDown = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="icon-chevron-down"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      strokeWidth="2"
      stroke="#bfbfbf"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M6 9l6 6l6 -6" />
    </svg>
  )
}

const DropSelect = ({
  opts = {},
  options = [],
  selectValues = [],
  onChange,
}) => {
  const { multiple, readonly } = opts

  return (
    <div className="flex-1">
      <Global
        styles={() => ({
          '.dark': {
            '.mantine-Select-input': {
              backgroundColor: 'unset',
              border: '1px solid var(--ow-color-darkTheme-800)',
              color: '#EAEDFF',
              fontSize: '14px',
            },
            '.mantine-MultiSelect-input': {
              backgroundColor: 'unset',
              border: '1px solid var(--ow-color-darkTheme-800)',
              color: '#EAEDFF',
              fontSize: '14px',
            },
            '.mantine-MultiSelect-dropdown': {
              border: '1px solid var(--ow-color-darkTheme-800)',
              background: 'var(--ow-color-darkTheme-1100)',
              color: '#EAEDFF',
              fontSize: '14px',
            },
            '.mantine-MultiSelect-value': {
              background: 'var(--ow-color-darkTheme-900)',
              color: '#EAEDFF',
              fontSize: '14px',
            },

            '.mantine-MultiSelect-defaultValueRemove': {
              color: '#EAEDFF',
            },
            '.mantine-MultiSelect-item': {
              color: '#EAEDFF',
              '&[data-selected]': {
                '&, &:hover': {
                  background: 'var(--ow-color-primary-700)',
                },
              },
              '&[data-hovered]': {
                background: 'var(--ow-color-darkTheme-900)',
              },
            },
            '.mantine-Select-item': {
              color: '#EAEDFF',
              '&[data-selected]': {
                '&, &:hover': {
                  background: 'var(--ow-color-primary-700)',
                },
              },
              '&[data-hovered]': {
                background: 'var(--ow-color-darkTheme-900)',
              },
            },
          },
        })}
      />
      {multiple ? (
        <MultiSelect
          data={options}
          disabled={readonly}
          rightSection={<IconChevronDown />}
          placeholder={opts.hint || opts.intro}
          value={selectValues}
          searchable
          onChange={(v) => {
            onChange(options.filter((o) => v.includes(o.value)))
          }}
        />
      ) : (
        <Select
          styles={{
            dropdown: {
              borderStyle: 'solid',
            },
          }}
          searchable
          disabled={readonly}
          onChange={(v) => {
            onChange(options.find((o) => o.value === v))
          }}
          value={selectValues && selectValues.length > 0 && selectValues[0]}
          data={options}
          placeholder={opts.hint || opts.intro}
          rightSection={<IconChevronDown />}
        />
      )}
    </div>
  )
}

export default DropSelect
